module.exports = __webpack_public_path__ + "assets/f654a557414cb50414168d2f2bdba316.png";